import {httpClient} from '../../common/api/HttpClient';

export const accountApi = {
    login: (login, password) => httpClient.post('public/login', {
        login,
        password
    }),
    checkState: () => httpClient.get('accounts/me'),
    findById: (accountId) => httpClient.get(`accounts/${accountId}`),
    findMe: () => httpClient.get('accounts/me'),
    logout: () => httpClient.get('public/logout'),
    getNewCaptcha: () => httpClient.get('public/captcha'),
    delete: (id) => httpClient.delete(`accounts/?accountId=${id}`),
    createOrUpdate: (account) => httpClient.post('accounts', account),
    register: (account) => httpClient.post('public/register', account),
    verify: (accountId) => httpClient.post(`accounts/verify/${accountId}`),
    rejectAccountVerification: (accountId) => httpClient.post(`accounts/reject/${accountId}`),
    resendConfirmationMail: (accountId) => httpClient.post(`accounts/resendDOI/${accountId}`),
    requestPasswordReset: (email) => httpClient.post(`public/request-password/${email}`),
    requestConfirmationLink: (email) => httpClient.post(`public/request-confirmation/${email}`),
    passwordReset: (token, email, password) => httpClient.post('public/password-reset', {
        token,
        email,
        password
    }),
    checkTokenValidity: (email, token) => httpClient.get(`public/checkToken?email=${email}&token=${token}`),
    confirmAccount: (token, email) => httpClient.post(`public/confirmAccount?token=${token}&email=${email}`),
    addAccount: (account) => httpClient.post('accounts/add-account', account),
    adminFetchAccounts: () => httpClient.get('accounts/admin-fetch-accounts'),
    adminSetAccountRole: (account) => httpClient.post('accounts/admin-set-role', account),
    findByClubId: (clubId) => httpClient.get(`accounts/?clubId=${clubId}`),
    findTrainers: () => httpClient.get(`accounts/trainers`),
    getRolesToAdd: (clubId) => httpClient.get(`accounts/add-roles/${clubId}`)
};

export default accountApi;
